/* eslint-disable */
export default {
  cancel: 'Cancelar',
  reply: 'Responder',
  onMyWay: 'En camino',
  customMessage: 'Mensaje personalizado',
  callMeBackIn: 'Devuélvame la llamada en',
  willCallYouBackIn: 'Le devolveré la llamada en',
  min: 'min',
  hours: 'horas',
  days: 'días',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"onMyWay"@#@ @source: @#@"On my way"@#@
// @key: @#@"customMessage"@#@ @source: @#@"Custom Message"@#@
// @key: @#@"callMeBackIn"@#@ @source: @#@"Call me back in"@#@
// @key: @#@"willCallYouBackIn"@#@ @source: @#@"Will call you back in"@#@
// @key: @#@"min"@#@ @source: @#@"min"@#@
// @key: @#@"hours"@#@ @source: @#@"hours"@#@
// @key: @#@"days"@#@ @source: @#@"days"@#@
